import { ref } from 'vue';

export default () => {
  const isMobile = ref<boolean>(window.outerWidth <= 768);
  window.addEventListener('resize', () => {
    isMobile.value = window.outerWidth <= 768;
  });
  return { isMobile };
};
